export enum Constants {
  COLLECTIONS_ADD_NEW_COLLECTION = 'COLLECTIONS_ADD_NEW_COLLECTION',
  COLLECTIONS_SET_LOADING = 'COLLECTIONS_SET_LOADING',
  COLLECTIONS_SET_COLLECTIONS = 'COLLECTIONS_SET_COLLECTIONS'
}